<mat-form-field
  class="three-quarter-width padded-top"
  [appearance]="appearance"
>
  <mat-label *ngIf="labelText">{{ labelText }}</mat-label>
  <input
    type="text"
    [placeholder]="placeholder"
    matInput
    name="entity{{ randomString }}"
    [(ngModel)]="entityValue"
    [formControl]="entityCtrl"
    [matAutocomplete]="auto"
    [required]="required"
    (keyup)="onTextChanged($event)"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)" [displayWith]="displayFn">
    <mat-option
      *ngFor="let entity of filteredEntities | async"
      [value]="entity"
    >
      <ng-container *ngIf="entityType === 'Retailer'">
        <span> {{ entity.entityName }}</span>
        <span *ngIf="entity.tradeAsName"> (DBA: {{ entity.tradeAsName }})</span>
        <span> // {{ entity.city }}, {{ entity.state ?? "MD" }} </span>
        <span *ngIf="entity.crNum"> // CR Number: {{ entity.crNum }})</span>
      </ng-container>

      <ng-container *ngIf="entityType === 'Wholesaler'">
        <span> {{ entity.wholesalerEntityName }}</span>
        <span *ngIf="entity.tradeAsName">
          (DBA: {{ entity.wholesalerTradeAsName }})</span
        >
        <span> // {{ entity.city }}, {{ entity.state ?? "MD" }} </span>
        <span *ngIf="entity.crNum"> // CR Number: {{ entity.crNum }})</span>
      </ng-container>
    </mat-option>
  </mat-autocomplete>
  <mat-hint *ngIf="isLoading">
    <i class="fa fa-spinner fa-spin"></i>
    Loading...
  </mat-hint>
</mat-form-field>
